import axios from '@/libs/api.request'

export const agentList = data => {
  return axios.request({
    url: '/print/agent/list',
    params: data,
    method: 'get'
  })
}
export const agentStatus = data => {
  return axios.request({
    url: '/print/agent/status',
    data,
    method: 'put'
  })
}
export const agentInfo = id => {
  return axios.request({
    url: `/print/agent/info?id=${id}`,
    method: 'get'
  })
}
export const agentSave = data => {
  return axios.request({
    url: '/print/agent/save',
    data,
    method: 'put'
  })
}
export const agentInsert = data => {
  return axios.request({
    url: '/print/agent/insert',
    data,
    method: 'put'
  })
}
export const saveExtract = data => {
  return axios.request({
    url: '/print/agent/extract',
    data,
    method: 'put'
  })
}
export const AgentMachine = data => {
  return axios.request({
    url: '/print/agent/machine',
    params: data,
    method: 'get'
  })
}
export const SearchAgent = data => {
  return axios.request({
    url: '/print/agent/search',
    params: data,
    method: 'get'
  })
}
export const BuyMeterIncrement = data => {
  return axios.request({
    url: '/print/agent/meter/increment',
    data,
    method: 'put'
  })
}
export const BuyIncrement = data => {
  return axios.request({
    url: '/print/agent/increment',
    data,
    method: 'put'
  })
}
export const AgentIncrementRecharge = data => {
  return axios.request({
    url: '/print/agent/AgentIncrementRecharge',
    data,
    method: 'put'
  })
}
export const MeterIncrementApply = data => {
  return axios.request({
    url: '/print/agent/meter/increment/apply',
    data,
    method: 'put'
  })
}
export const TransferMeterIncrement = data => {
  return axios.request({
    url: `/print/agent/meter/increment/transfer?data=${JSON.stringify(data.data)}`,
    data: data.file,
    method: 'put'
  })
}
export const TransferIncrement = data => {
  return axios.request({
    url: `/print/agent/increment/transfer?data=${JSON.stringify(data.data)}`,
    data: data.file,
    method: 'put'
  })
}
export const GetIncrement = data => {
  return axios.request({
    url: '/print/agent/increment',
    params: data,
    method: 'get'
  })
}
export const IncrementApply = data => {
  return axios.request({
    url: '/print/agent/increment/apply',
    data,
    method: 'put'
  })
}
export const DismissIncrement = data => {
  return axios.request({
    url: '/print/agent/increment/dismiss',
    data,
    method: 'put'
  })
}
export const IncrementDelete = data => {
  return axios.request({
    url: '/print/agent/increment/del',
    data,
    method: 'put'
  })
}
export const GetOperateCode = data => {
  return axios.request({
    url: '/print/operate/code/one',
    params: data,
    method: 'get'
  })
}
export const GetAgentOperateCode = data => {
  return axios.request({
    url: '/print/agent/operate/code',
    params: data,
    method: 'get'
  })
}
export const ActivateCode = data => {
  return axios.request({
    url: '/print/operate/code/activate',
    data,
    method: 'put'
  })
}
export const SaveLogo = data => {
  return axios.request({
    url: '/print/agent/logo',
    data,
    method: 'post'
  })
}
export const SaveAgentLogo = data => {
  return axios.request({
    url: '/print/agent/user/logo',
    data,
    method: 'post'
  })
}
export const MakeActivation = data => {
  return axios.request({
    url: '/print/agent/make/activation',
    data,
    method: 'put'
  })
}
export const SendTelCode = data => {
  return axios.request({
    url: '/print/agent/SendTelCode',
    data,
    method: 'post'
  })
}
export const AgentSaveLeader = data => {
  return axios.request({
    url: '/print/agent/AgentSaveLeader',
    data,
    method: 'post'
  })
}
export const CodeCheck = data => {
  return axios.request({
    url: '/print/agent/code/check',
    data,
    method: 'post'
  })
}
export const GetProfitReport = data => {
  return axios.request({
    url: '/print/agent/ProfitReport',
    params: data,
    method: 'get'
  })
}

export const GetAgentTrack = data => {
  return axios.request({
    url: '/print/agent/track',
    params: data,
    method: 'get'
  })
}
export const SaveAgentTrack = data => {
  return axios.request({
    url: '/print/agent/track',
    data,
    method: 'post'
  })
}
export const SaveAgentFunc = data => {
  return axios.request({
    url: '/print/agent/SaveAgentFunc',
    data,
    method: 'post'
  })
}
export const SaveAgentNoMoneyPrint = data => {
  return axios.request({
    url: '/print/agent/SaveAgentNoMoneyPrint',
    data,
    method: 'post'
  })
}

export const GetAgentMoneyBill = params => {
  return axios.request({
    url: '/print/agent/GetAgentMoneyBill',
    params,
    method: 'get'
  })
}

export const SaveAgentBaseDeliverFee = data => {
  return axios.request({
    url: '/print/agent/SaveAgentBaseDeliverFee',
    data,
    method: 'post'
  })
}
